import React from "react";
import { useSelector } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import CurrencyFormat from 'react-currency-format';
import {
    Card,
    CardBody,
  } from "reactstrap";

const MonthlyEarning = () => {
    const { data, loading } = useSelector(state => ({
        data: state.Dashboard.data,
        loading: state.Dashboard.loading,
    }));

    return <Card className="mini-stats-wid">
        <CardBody>
            <div className="d-flex">
                <div className="flex-grow-1">
                    <p className="text-muted fw-medium">Monthly Earnings</p>
                    <div className="mb-0 d-flex">
                        {!loading && <CurrencyFormat value={data?.monthlyEarnings?.nominal ?? '-'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2} displayType={'text'} />}
                        <PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" />
                        {!loading && data && data?.monthlyEarnings?.status &&
                            <span className="text-success ms-2"> {data?.monthlyEarnings?.persentase}% <i className="mdi mdi-arrow-up"></i> </span>}
                        {!loading && data && data?.monthlyEarnings?.status == false &&
                            <span className="text-danger ms-2"> {data?.monthlyEarnings?.persentase}% <i className="mdi mdi-arrow-down"></i> </span>}
                    </div>
                </div>
                <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                    <span className="avatar-title">
                        <i className="bx bx bx-download font-size-24"></i>
                    </span>
                </div>
            </div>
        </CardBody>
    </Card>
}

export { MonthlyEarning }